import { render, staticRenderFns } from "./StepTitle.vue?vue&type=template&id=31f51141&scoped=true&"
import script from "./StepTitle.vue?vue&type=script&lang=js&"
export * from "./StepTitle.vue?vue&type=script&lang=js&"
import style0 from "./StepTitle.vue?vue&type=style&index=0&id=31f51141&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f51141",
  null
  
)

export default component.exports